// extracted by mini-css-extract-plugin
module.exports = {"container":"SafeName_container_1juOY","goBack":"SafeName_goBack_1tDh0"};